import {
  ElementNode,
  DOMConversionMap,
  SerializedElementNode,
  EditorConfig,
  LexicalEditor,
} from 'lexical';
import { addClassNamesToElement } from '@lexical/utils';

export type SerializedLayoutItemNode = SerializedElementNode;

export class LayoutItemNode extends ElementNode {
  static getType() {
    return 'layout-item';
  }

  static clone(node: LayoutItemNode) {
    return new LayoutItemNode(node.__key);
  }

  createDOM(config: EditorConfig, editor: LexicalEditor) {
    const dom = document.createElement('div');
    dom.className = 'PlaygroundEditorTheme__layoutItem';
    if (typeof config.theme.layoutItem === 'string') {
      addClassNamesToElement(dom, config.theme.layoutItem);
    }
    return dom;
  }

  updateDOM() {
    return false;
  }

  static importDOM(): DOMConversionMap | null {
    return {
      div: (domNode: HTMLElement) => {
        if (domNode.classList.contains('PlaygroundEditorTheme__layoutItem')) {
          return {
            conversion: () => ({
              node: $createLayoutItemNode(),
            }),
            priority: 3,
          };
        }
        return null;
      },
    };
  }

  static importJSON(): LayoutItemNode {
    return new LayoutItemNode();
  }

  exportJSON(): SerializedLayoutItemNode {
    return {
      ...super.exportJSON(),
      type: 'layout-item',
      version: 1,
    };
  }
}

export function $isLayoutItemNode(node: any): node is LayoutItemNode {
  return node instanceof LayoutItemNode;
}

export function $createLayoutItemNode(): LayoutItemNode {
  return new LayoutItemNode();
}
